import React, { forwardRef } from 'react';
import MaterialCheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from './FormControlLabel.jsx';
import FormGroup from './FormGroup.jsx';

function Checkbox(props, ref) {
  if (props.label) {
    return (
      <FormGroup row>
        <FormControlLabel
          control={
            <MaterialCheckbox
              ref={ref}
              color="primary"
              { ...props }
            />
          }
          label={props.label}
        />
      </FormGroup>
    )
  }
  return <MaterialCheckbox {...props} ref={ref} />
}

export default forwardRef(Checkbox);
